/** @deprecated */
export enum TASKS_GROUPS {
  OPEN = 'open',
  TODO = 'todo',
  CLOSED = 'closed',
  ARCHIVED = 'archived',
  ALL = 'all',
}
